// Myanmar Unicode language file
export const mmun_texts = [
	"Hello, ",
	"This is a test!",
	"လုပ်မည်",
	"မလုပ်ပါ",
	"ပိတ်ပါ",
	"English",
	"မြန်မာ",
	"普通话",
	"Kayin",
	"Rakhine",
	"Chin",
	"တႆး",
	"Jinghpaw",
	"ဆာဗာသို့ ဆက်သွယ်၍ မရပါ။ သင့်အင်တာနက်ဆက်သွယ်မှု ကောင်းမကောင်းစစ်ဆေးပါ။ အကယ်၍ ပြသနာရှိနေသေးပါက Support သို့ ဆက်သွယ်ပါရန်။",
	"မူလ",
	"အသစ်",
	"စျေးဝယ်",
	"Live",
	"ပေးစာ",
	"Studio",
	"ကျွန်ုပ်",
	"OK",
	"Error",
	"ဖျက်သိမ်း",
	"(ဖျက်ရန်ဘယ်ဖက်သို့ရွေ့)",
	"GOOGLE အကောင့်ဖြင့် ဝင်မည်",
	"APPLE အကောင့်ဖြင့် ဝင်မည်",
	"အီးမေးဖြင့် ဝင်မည်",
	"အီးမေးလ်",
	"Password",
	"Password မေ့နေလျှင်",
	"လော့ဂ်အင်",
	"မှတ်ပုံတင်ပါ",
	"အကောင့်မှ ထွက်ရန် သေချာပါသလား။",
	"အီးမေးလ်: ",
	"နာမည်ပြင်ဆင်",
	"ဓာတ်ပုံတင်",
	"ဘာသာစကား",
	"အကောင့်မှထွက်",
	"ခေတ္တစောင့်ပါ...",
	"အသစ်တင်",
	"ရွေးချယ်ပါ",
	"ဗီဒီရိုလင့်ခ့် ထည့်ရန်",
	"နောက်သို့",
	"မည်သို့လုပ်ဆောင်ရမည်နည်း",
	"YouTube Video Code:",
	"Video Title:",
	"Description:",
	"Category:",
	"Tags (optional):",
	"Upload တင်",
	"YouTube Video code မှာ မှားယွင်းနေပါသည်။ တင်လိုသော YouTube URL သို့မဟုတ် ဗီဒီရိုကုတ် သက်သက် ထည့်သွင်းနိုင်ပါသည်။",
	"Please add a video title before uploading the video.",
	"ပြန်ထွက်ပါက ထည့်သွင်းထားသော အချက်အလက်များ ပြန်ပျက်သွားမည် ဖြစ်ပါသည်။",
	"Upload မလုပ်ပါ",
	"ချိန်နယ်အသစ်",
	"ချိန်နယ်နာမည်:",
	"Description:",
	"Category:",
	"Create Channel",
	"Before you can upload your videos, you must create a channel for them. A user can have many channels to group different types of videos.",
	"Edit Channel",
	"Save",
	"Your Channel:",
	"Channel List:",
	"Your Videos:",
	"Description",
	"Edit Channel",
	"Delete Channel",
	"Are you sure you want to delete this channel and all its video? This cannot be undone.",
	"Upload Channel Image",
	"Edit Channel",
	"Manage All Channels",
	"YouTube Video code မှာ မှားယွင်းနေပါသည်။ တင်လိုသော YouTube URL သို့မဟုတ် ဗီဒီရိုကုတ် သက်သက် ထည့်သွင်းနိုင်ပါသည်။",
	"ချိန်နယ်:",
	"Your content was uploaded successfully!",
	"You do not have any video in this channel.",
	"Add One",
	"စာရိုက်ရန်...",
	"အီးမေးလ်ထည့်ပါ...",
	"ပုံတင်မည်",
	"ငွေလွှဲမည်",
	"ထပ်ကြည့်",
	"ဖျက်ပါ",
	"ဘလောက်ပါ",
	"ဘလောက်စာရင်း",
	"ဖျက်မည်",
	"မက်ဆေ့ချ်များ အားလုံး ဖျက်မည်လား။ ဖျက်ပြီးပါက ပြန်လည်ရယူ၍ ရနိုင်မည်မဟုတ်ပါ။",
	"ဘလောက်ပါ",
	"လက်ရှိအသုံးပြုသူကို ဘလောက်ပြုလုပ်မည်လား။",
	"အင်တာနက် ဆက်သွယ်မှု မရပါ",
	"အကူအညီရယူပါ",
	"သင့် ပြသနာများကို ကျွန်ုပ်တို့ ကူညီပါရစေ။ လိုအပ်သော အကူအညီကို အောက်တွင် မက်ဆေ့ချ်ပို့ထားနိုင်ပါသည်။ ကျွန်တော်တို့ အမြန်ဆုံး ပြန်ဆက်သွယ်ပါမည်။",
	"အချက်ပေးများ",
	"သင့်တွင် ပေးပို့ထားသော notification အသစ် မရှိသေးပါ။",
	"ဘလောက်ထားသူ မရှိသေးပါ",
	"တစုံတယောက်ကို ဘလောက် ထားပါက ဤနေရာတွင် ကြည့်ရှုနိုင်ပါသည်။",
	"ဘလောက်စာရင်း",
	"စာရင်းပယ်ဖျက်",
	"လက်ရှိအကောင့်အား သင့် ဘလောက်စာရင်းမှ ပယ်ဖျက်ရန် သဘောတူပါသလား။",
	"စာပို့၍ မရနိုင်ပါ...",
	"ငွေလွှဲသည့် နေ့စွဲ",
	"လွှဲချိန်ထပ်တိုးပေးပါ",
	"ပြန်စာ",
	"စာမျက်နှာ",
	"ဝင်စာ",
	"ရှာဖွေမည်...",
	"ပြန်စာမရှိသေး",
	"သင့်ကို ပေးပို့ထားသော စာမရှိသေးပါ။",
	"အသစ်တင်မည်",
	"ပို့စ်အသစ်",
	"ဗီဒီရိုလင့်ခ်",
	"ပုံအသစ်",
	"ပို့စ်အသစ်တင်",
	"မြင်ရမည့်သူများ",
	"သင့်တွင်ရှိသော USD",
	"ရှိသော LIKES (N-Tokens)",  
	"Likes (N-Tokens) ဝယ်ယူမည်",
	"သင့်တွင် N-Wallet မရှိသေးပါ",
	"သင့်ပိုက်ဆံနှင့် တိုကင်များကို စီမံခန့်ခွဲရန် N-Wallet ထည့်သွင်းဖို့ လိုအပ်ပါသည်။",
	"N-Wallet ရယူမည်",
	"သင့်ပိုက်ဆံများကို စီမံခန့်ခွဲရန်",
	"N-Wallet ဖြင့် သင့်ပိုက်ဆံနှင့် တိုကင်များကို စီမံခန့်ခွဲခြင်း၊ ငွေလွဲခြင်းများ ပြုလုပ်နိုင်ပါသည်။",
	"N-Wallet ဖွင့်ပါ",
	"N-Social Games",
	"သူငယ်ချင်းများနှင့် ဂိမ်းအတူတူဆော့မည်။ တချို့ဂိမ်းများ ကစားခြင်းဖြင့်လည်း Likes များအနိုင်ရရှိနိုင်ပါသည်။",
	"ဂိမ်းများ ကစားမည်",
	"App များအားလုံး",
	"Hightlight",
	"App အသစ်",
	"ဂိမ်း",
	"တိုက်ရိုက် APK ဒေါင်းမည်",
	"AppStore မှ ရယူမည်",
	"Google Playstore မှရယူမည်",
	"(ဖုန်းအနှိမ့် Android ဖုန်းများသာ)",
	"သင့်ပိုက်ဆံအိပ်",
	"ကောမန့်များ",
	"Like မပေးခင် ဒီဟာကို ဖတ်ပါ",
	"N-Social  ထဲတွင် Likeပေး‌ခြင်းသည် တခြားသော social media များနှင့်မတူပါ။ Like တခါပေးတိုင်း N-Token တခုကို အသုံးပြုရပါမည်။ အပေးခံရသူသည် ၎င်း N-token ကို ရရှိမည် ဖြစ်ပါသည်။ N-token ကို ဝယ်ယူရရှိနိုင်သလို၊ ဂိမ်းများကစားပြီး ကြော်ငြာကြည့်ပေးခြင်းဖြင့် token များ အလကားရယူနိုင်ပါသည်။ ",
	"နားလည်ပါပြီ",
	"အခမဲ့ N-Tokens ရယူမည်",
	"Super LIKE ဆိုတာ ဘာလဲ?",
	"N-Social  တွင် ပို့စ်တခုကို Like အရေအတွက် အကန့်အသပ်မရှိ ပေးနိုင်ပါသည်။ Like ပေးခြင်းသည် ပို့စ်ပိုင်ရှင်ကို သင်မည်မျှ နှစ်သက်ကြောင်း ပြောရာရောက်ပါသည်။ များများကြိုက်က များများ  Like နိုင်ပါသည်။ Super Like သည် တခါထဲ Like ဆယ်ခုပေးခြင်းနှင့် ညီမျှပါသည်။ ",
	"Like ပေးရန် သင့်တွင် N-token မရှိသေးပါ။ N-token ကို ဝယ်ယူရရှိနိုင်သလို၊ ဂိမ်းများကစားပြီး အခမဲ့ ရယူနိုင်ပါသည်။",
	"ဦးဆုံးသူအဖြစ် ယခုပို့စ်ကို Like လုပ်ပါ...",
	"ကောမန့် ရေးပေးပါ...",
	"ဦးဆုံးသူအဖြစ် ယခုပို့စ်တွင် ကောမန့်ရေး ပေးပါ...",
	"N-token များကို ဝယ်ယူရန် N-Wallet ကို ထည့်သွင် setup လုပ်ထားရန် လိုအပ်ပါသည်။",
	"X-Rate: ",
	"LIKES (N-Tokens):",
	"LIKES ဝယ်မည်",
	"ဖျက်",
	"သင့်တွင် လိုအပ်သော LIKES (N-Tokens) ဝယ်ရန် ငွေလက်ကျန် မရှိသေးပါ။",
	"သင့်ရှိ USD:",
	"USD စျေး -",
	"ငွေလှဲနှုန်း -",
	"လက်ခံရရှိမည့် LIKES (N-Tokens) -",
	"လက်ကျန် USD -",
	"LIKES ဝယ်ယူမည်",
	"ဝယ်ယူမှု အတည်ပြု",
	"ဖျက်",
	"အတည်ပြု",
	"သင့် Passkey ထည့်သွင်းပါ",
	"USD စုစုပေါင်း -",
	"LIKES (N-Tokens) -",
	"ပြန်ထွက်",
	"ဝယ်ယူမှု အောင်မြင်ပါသည်",
	"ကြည့်",
	"LIKE စျေးနှုန်း",
	"(N-Token ငွေလှဲနှုန်း)",
	"updated: ",
	"LIKES ဝယ်ယူပါ",
	"ရှာဖွေပါ...",
	"မက်စေ့",
	"Follow လုပ်မည်",
	"Follow ပြန်ဖြုတ်",
	"သူငယ်ချင်း",
	"Followed",
	"အပြင်ကို ရှဲလ်ပါ",
	"အက်မင်ကို တိုင်မည်",
	"ဘလောက်ပါ",
	"Followers",
	"ပရိုဖိုင်ပြင်ရန်",
	"Follow လုပ်မည်",
	"Follow လုပ်မည်",
	"Follow ပြန်ဖြုတ်",
	"ပို့စ်ဖျက်မည်",
	"ပို့စ်ဖျက်မည်?",
	"ယခုတင်ထားသော ပို့စ်ကိုဖျက်လျှင် ကောမန့်များပါ ပျက်ပါမည်။ ပြန်လည်ရယူရလိမ့်မည် မဟုတ်ပါ။ ရှေ့ဆက်မည်လား။",
	"အကောင့်မှထွက်မည်လား",
	"Followers: ",
	"ဒီပို့စ်ကို အရေးယူသင့်သော အကြောင်းရင်းကို သေချာရှင်းလင်းပေးပါ။ အကြောင်းရင်း သေချာသိမှသာ အက်မင်များမှ လိုအပ်သော အရေးယူမှုများ ပြုလုပ်နိုင်ပါလိမ့်မယ်။ အကယ်၍ အကြောင်းရင်း သေချာ မရေးပေးပါက အရေးယူသင့်သော ပို့စ်ဖြစ်သည့်တိုင်၊ အင်မင်များမှ တွေ့ရှိလိမ့်မည် မဟုတ်ပါ။ ယခုလို အချိန်ယူပြီး သန့်ရှင်းသော ပတ်ဝန်ကျင်ဖြစ်ရန် တာဝန်ယူမှုအတွက် N-Social မှ ကျေးဇူးတင်ရှိပါသည်။ ",
	"တိုင်ရသည့် အကြောင်းရင်း",
	"သင်တိုင်ကြားမှုကို ကျွန်ုပ်တို့ ရရှိပါသည်။ အက်မင်များမှ အရေးယူရန် ဆက်လက်ဆောင်ရွက်သွားမည် ဖြစ်ပါသည်။",
	"အချက်ပေးချက်များ",
	"မဖတ်ရသေး",
	"အားလုံး",
	"အားပေးသူများ",
	"ပို့စ်မှားယွင်းနေပါသည်",
	"သင်ရှာဖွေသော ပို့စ်မှာ ဖျက်သိမ်းခြင်း သို့ error တခုခု ဖြစ်နေပါသည်။",
	"Password မေ့နေလျှင်",
	"Password ကို reset ချရန် အီးမေးလ် ထည့်သွင်းပါ",
	"Password ကို Reset ချ",
	"အကောင့်သစ် ဖန်တီးပါ",
	"အီးမေးလ် မှားယွင်းနေပါသည်။",
	"Password သည်အနဲဆုံး ၆ လုံးရှိရန် လိုအပ်သည်",
	"Confirm Password:",
	"သင့် password နှစ်ခု တူညီခြင်း မရှိပါ",
	"Referral Email:",
	"မှတ်ပုံတင်ပါ",
	"(သင့်အချက်အလက်များကို မည်သူကိုမျှ ပေးမည်မဟုတ်)",
	"Your Referral ID (မလိုအပ်)",
	"အီးမေးလ်အတည်ပြုပါ",
	"အတည်ပြုရန် သင့်ဆီသို့ အီးမေးလ်တစောင် ပို့ထားပါသည်။ အထဲတွင်ရှိသော လင့်ခ်ကို နှိပ်၍ အတည်ပြုပေးပါ။",
	"အီးမေးလ် အတည်ပြုပြီးပါပီ",
	"အီးမေးလ် ထပ်ပို့ပါ",
	"အီးမေးလ် အတည်ပြုခြင်း အောင်မြင်ပါသည်။",
	"အတည်ပြုရန် အီးမေးလ်ထပ်မံ ပို့ဆောင်ထားပါသည်။ မရသေးပါက သင့် folder အားလုံး spam folder အပါအဝင် စစ်ဆေးကြည့်ပါ။",
	"နာမည်ပြင်ဆင်",
	"နာမည်သစ် ထည့်သွင်းပါ",
	"နာမည်ပြောင်းပါ",
	"ဘာသာစကား ရွေးချယ်ပါ",
	"ပြောင်းပါ",
	"English",
	"Mandarin",
	"Myanmar",
	"ပို့စ်တင်",
	"ပို့စ်တွင် ထည့်သွင်းရန်",
	"ဓာတ်ပုံ",
	"ဗီဒီယိုဖိုင်",
	"YouTube ဗီဒီယို",
	"စာခေါင်းစီး",
	"မေးခွန်း",
	"ပိတ်ပါ",
	"YouTube ဗီဒီရိုလပ်စာ ထည့်ရန်",
	"စာခေါင်းစီး ထည့်ရန်",
	"ဘာပြောချင်တာလဲ...",
	"အဆုံးရောက်ပါပီ",
	"LIKE ပေးပြီး ဖွင့်ရန်",
	"SUPER-LIKE ဖြင့် ဖွင့်ရန်",
	"LIKE ပေးပြီး ဆက်ကြည့်ရန်",
	"SUPER-LIKE ဖြင့် ဆက်ကြည့်ရန်",
	"သူများတင်သော ပို့စ်များဖတ်ရန် သင်ကြိုက်နှစ်သက်သော သူများကို Follow ထားရန်လိုအပ်ပါသည်။ \"အသစ်\" ကိုနှိပ်၍ တခြားသူများ တင်သော ပို့စ်များကို မြည်းစမ်းနိုင်ပါသည်။ ကြိုက်နှစ်သက်ပါက Follow  လုပ်ထားပြီး ဆက်ကြည့်နိုင်သည်။ ",
	"ပို့စ် \"အသစ်\" များကြည့်ရန်",
	"Follow ထားသူများ",
	"ဓာတ်ပုံများ",
	"လူကြိုက်များ",
	"သတင်းမီဒီယာ",
	"ပေါ်ပြူလာ",
	"နောက်ဆုံးတင်",
	"၁၈ အပေါင်း",
	"လက်ရှိစာရင်းတွေ တင်ထားသော ပို့စ်မရှိသေးပါ။ တခြားစာရင်းများကို ကြည့်ရှုနိုင်ပါသည်။",
	"ကောမန့်လိုက်ခ်ထားသူများ",
	"စာကို ကော်ပီကူးပါ",
	"ကောမန့် ဖျက်ပါ",
	"ဖျက်မည်",
	"လက်ရှိကောမန့်ကို အပြီး ဖျက်မည်လား။",
	"သူငယ်ချင်း",
	"Followers",
	"လာ Follow သူ",
	"You have no friend yet",
	"Follow other people and when they followed you back, you will become friends. Friends can see each other private posts!",
	"You haven't follow anybody yet",
	"You can follow other people if you like their posts so you can see them everytime they post!",
	"You have no follower",
	"If other people follow you, they will be shown here!",
	"အကြောင်းပြန်မည်",
	"အားလုံး",
	"ကြိုက်သူ",
	"မကြိုက်သူ",
	"အကြောင်းပြန်စာ",
	"ပရိုဖိုင်ကို ရှဲလ်မည်",
	"Update အသစ်ရပါပြီ",
	"အသစ်ပြင်ဆင်ထားမှု -",
	"PlayStore မှ ရယူမည်",
	"AppStore မှ ရယူမည်",
	"တိုက်ရိုက် ဒေါင်းလုဒ်ဆွဲမည်",
	"App is in maintenance mode",
	"We Are Sorry!!",
	"Check Again",
	"18+ ပို့စ်",
	" မှ ဒီပို့စ်ကို ",
	" ပေးခဲ့သည်။",
	"အမည်ဖျောက်",
	"အမည်ပျောက် ကောမန့်",
	"Gif ပို့မည်",
	"လောလောဆယ် File Size ",
	" MB အထိသာ တင်ခွင့်ပြုထားပါသည်။ အနာဂတ်တွင်တော့ ဆိုဒ်အကြီးတွေပါ တင်နိုင်အောင် ကြိုးစားသွားပါ်မည်။",
	"ဘုံချက်",
	"ဘုံချက်မှနောက်ဆုံးပို့စာ",
	"ဘုံချက်ကို Join မည်",
	"ပြောနေသူများ",
	"[ဘုံချက်] ",
	"စာအနေဖြင့် ရှဲမည်",
	"မက်စေ့ဖျက်မည်",
	"အကြောင်းပြန်မည်",
	"ချက်ဘောက်စ်ပိတ်ပါ",
	"ချက်ဘောက်စ်ပြန်ဖွင့်ပါ",
	"ချက်ဘောက်စ်မှာ ပိုင်ရှင်မှ ပိတ်ထားပါသည်။",
	"မက်စေ့ကိုဖျက်ထားပါသည်",
	"အနဲဆုံးစကားလုံး - ",
	"ဘက်ဂရောင်းပြောင်း",
	"ဘက်ဂရောင်းဖျက်",
	"ဘုံချက်သို့ ရှဲလ်မည်",
	"ဘုံချက်သို့ ပို့စ်ကိုရှဲလ်ပြီးပါပြီ။",
	"ပို့စ်ရှဲလ်ထားသည် - ",
	"Replies",
	"See All",
	"Like ပေးစရာ မရှိသေးပါ",
	"Like ပေးရန် သင့်တွင် Likes များရှိထားဖို့ လိုအပ်ပါသည်။ Like ကိုဝယ်ယူနိုင်သလို၊ တခြားသူများမှ Like ပေးလျှင်လဲရနိုင်ပါသည်။",
	"(သို့) ကြော်ငြာများကြည့်၍ Like ရယူနိုင်သည် (မှတ်ချက်၊ ကြော်ငြာကြည့်ပြီး တနာရီကြာမှ Like ရပါမည်)",
	"နားလည်ပါပြီ",
	"ကြော်ငြာကြည့်မည်",
	"(သို့) ကြော်ငြာများကြည့်၍ Like ရယူနိုင်သည် (မှတ်ချက်၊ လောလောဆယ်ကြော်ငြာမရှိသေးပါ၊ ခဏကြာမှ ပြန်ဝင်ကြည့်ပေးပါ)",
	"ကြော်ငြာမရှိသေးပါ",
	"ဘုံချက်နာမည်ပြောင်း",
	"ဘုံချက်နာမည်",
	"ပြောင်းချင်သည့် ဘုံချက်နာမည်",
	"ပြောင်းပါ",
	"ကျပန်းမိတ်ဖွဲ့",
	"သူငယ်ချင်းသစ်တွေ ရှာမယ်",
	"ထွက်မည်လား?",
	"ထွက်ခဲ့လျှင် သင့်ပရိုဖိုင်ကို အစကပြန်လည်ဖန်တီးရန် လိုအပ်ပါမည်။",
	"ပရိုဖိုင် ဖန်တီးခြင်း",
	"ကျပန်းမိဆက်ခန်းသို့ ချိတ်ဆက်နေပါပြီ",
	"ဆာဗာသို့ အဆက်အသွယ်ရရန် ခေတ္တစောင့်ပါ...",
	"Connection Error",
	"ဆာဗာသို့ ဆက်သွယ်မရပါ။ မကြာခင် ပြန်လည်ချိတ်ဆက်ပါမည်...",
	"ပရိုဖိုင်ဖန်တီးနေသည်",
	"သင့်ပရိုဖိုင်ကို အပြီးဖန်တီးပြီး မိတ်ဆက်ခန်း ဆီဝင်ရောက်ပါ။",
	"နာမည်ပြောင်",
	"သင့်ပုံကို ရွေးချယ်ပါ",
	"သင်သည်",
	"စကားပြောချင်သူ",
	"ကောင်လေး",
	"ကောင်မလေး",
	"၂ ခုလုံး",
	"Disconnecting",
	"ဆာဗာချိတ်ဆက်မှု ပြန်လည်ဖြတ်တောက်နေပါသည်...",
	"ခေတ္တစောင့်ပါ",
	"စကားပြောသူကို ရှာဖွေနေပါသည်။ ဆာဗာတွင် စကားပြောသူ ",
	" ယောက် ရှိပါသည်။",
	"ထွက်သွားပါသည်",
	"တခြားစကားပြောသူ ထွက်သွားပါသည်။ နောက်တခြားလူနှင့် ပြန်လည်ချိတ်ဆက်နေပါသည်...",
	"နောက်လူသို့",
	"သူငယ်ချင်းဖွဲ့ရန်",
	"Reveal Identity",
	"သူငယ်ချင်းဖွဲ့ရန် လက်ခံမည်လား?",
	"ထွက်ပါ",
	"ဝင်မည်",
	"Action Button များ",
	"ဘုံချက်ဖိတ်ခေါ် ခလုတ်",
	"လက်ရှိလိုင်းပေါ်ရှိသောသူများ - ",
	"Video was deleted or there was an error in upload",
	"ကြည့်စရာ ဗီဒီယိုများ မရှိသေးပါ။ ခဏနေမှ ဝင်ရောက်ကြည့်ရှုပါ။",
	"ဘုံချက်ကို Join မည်",
	"• စပွန်ဆာပေးထားသည်",
	"'စပွန်ဆာ' ဆိုတာဘာလဲ",
	"စပွန်ဆာ ပေးထားသည်ကိုတွေ့ပါက ဖွင့်ကြည့်လျှင် Like token များရရှိပါမည်။ ကုမ္ပဏီများမှ ၎င်းတို့ post များကို လူများများကြည့်စေရန် ပိုက်ဆံပေးကြော်ငြာခိုင်းပြီး၊ N-Social မှ အသုံးပြုသူများသို့ ပြန်လည်ပေးအပ်ခြင်းဖြစ်ပါသည်။",
	"နားလည်ပါပြီ",
	"ပို့စ်ကို Boost မည်",
	"ပို့စ်စပွန်ဆာ",
	"ပို့စ်ကို Boost ပါ",
	"Tokens ဝယ်မည်",
	"အသုံးပြုလိုသော တိုကင်အရေအတွက် -",
	"သက်ရောက်မည့် အသုံးပြုသူအရေအတွက်",
	"သင်ရွေးချယ်ထားသော အရေအတွက် မှားယွင်းနေပါသည်။",
	"Boost ကိုပြန်ဖျက်မည်",
	"Boost ခဏရပ်ထား",
	"Boost ရပ်ထားတာပြန်စ",
	"သင် Boost ထားသော တိုကင်အရေအတွက်",
	"အသုံးပြုပြီးသော တိုကင်အရေအတွက်",
	"Boost ဖျက်မည်",
	"ပို့စ် boost ထားတာကို ပြန်ဖျက်ပြီး တိုကင်များ ပြန်ရယူမည်။ မှတ်ချက်၊ တချို့တိုကင်များသည် အသုံးပြုသူများဆီ ရောက်ပြီးဖြစ်နေနိုင်ပါသည်။",
	"စပွန်ဆာပိုစ့်ကို ကြည့်ရှုသည့်အတွက် ကြော်ငြာရှင်ထံမှ LIKE တိုကင်တချို့ ရရှိပါသည်။",
	"ရှေ့ဗီဒီယိုကြည့်ရန် အောက်သို့ ဆွဲချပါ",
	"နောက်ဗီဒီယိုကြည့်ရန် အပေါ်ကို ဆွဲတင်ပါ",
	"လှို့ဝှက်နံပါတ် အသစ် ထည့်သွင်းပါ",
	"လှို့ဝှက်နံပါတ်ကို ငွေလွှဲရာတွင် လုံခြုံရေးအနေဖြင့် အသုံးပြုပါသည်။ သင် အလွယ်တကူ မှတ်မိနိုင်သော နံပါတ် (ဥပမာ၊ မွေးနေ့ စသည်) ကိုသာ အသုံးပြုပါရန်။",
	"ငွေလွဲမည်",
	"ပေးပို့လိုသောပမာဏ",
	"ပိုက်ဆံလွဲပါ",
	"သင်လက်ကျန်ငွေစာရင်း",
	"သင်ပေးပို့သော ငွေပမာဏသည် သင့်တွင်ရှိသော ငွေစာရင်းထက် များနေပါသည်။",
	"ငွေလွဲထားသည်",
	"ပိုက်ဆံအိပ်ဖွင့်",
	"စျေးကွက်",
	"Apps",
	"ပိုက်ဆံအိတ်",
	"ပစ္စည်းများ ရှာဖွေမည်...",
	"စျေးနှုန်း - ",
	"တည်နေရာ - ",
	"ပစ္စည်းအမျိုးအစား",
	"သင့်ပစ္စည်းအမျိုးအစားရွေးချယ်ပါ",
	"စျေးနှုန်း",
	"အမျိုးအစား",
	"ရရှိနိုင်သော နေရာများ",
	"တည်နေရာထည့်ပါ",
	"တည်နေရာ ရွေးချယ်ပါ",
	"You need to select a category for your item before you can post to marketplace",
	"You need to select at least one location for your item before you can post to marketplace",
	"You need to pick at least one image or video for your item before you can post to marketplace",
	"အမျိုးအစား",
	"ရောင်းမည်",
	"မြန်မာနိုင်ငံ",
	"တင်ထားသူ",
	"ဒီပစ္စည်းကို စိတ်ဝင်စားလို့၊ သူ့အကြောင်းကို အသေးစိတ် သိချင်ပါတယ်။",
	"ရောင်းသူထံ စုံစမ်းမည်",
	"ရောင်းသူဆီသို့ စာပို့ပြီးပါပီ။ သူစာအပြန်ကို ခေတ္တစောင့်ဆိုင်းပေးပါ။",
	"မှာယူရရှိနိုင်သော နေရာများ",
	"အမျိုးအစား ရွေးချယ်ပါ",
	"Search",
	"Cancel",
	"လောလောဆယ် စျေးကွက်ပေါ်တွင် သင်ရှာဖွေနေသော ပစ္စည်း မရှိသေးပါ။ ရှာဖွေမှုအသစ်ပြန်လည်ပြုလုပ်ပါ။",
	"ငွေပေးချေမှု",
	"ငွေပေးချေမည်",
	"ပိတ်ပါ",
	"ငွေပေးချေမှု အောင်မြင်ပါသည်",
	"နောက်ဆုံးသုံးခဲ့သော",
	"စျေးနှုန်း - ",
	"ပို့စ်ရှဲမည်",
	"ဒီပို့စ်ကို ရှဲမည်",
	"ပိတ်ပါ",
	"ငွေလဲ",
	"LIKES ဝယ်",
	"ငွေဖြည့်",
	"ငွေထုတ်",
	"N-Token Amount To Exchange",
	"USD ငွေလဲလှယ်မှု",
	"USD ပမာဏ",
	"ငွေလဲလှယ်မည်",
	"လဲလှယ်မည့် LIKES (N-Tokens)",
	"ငွေလဲနှုန်း",
	"လဲလှယ်ရရှိမည့် USD",
	"ကျန်ရှိမည့် LIKES (N-Tokens)",
	"ငွေလဲလှယ်မှု အတည်ပြု",
	"ငွေလဲမှု အောင်မြင်ပါသည်",
	"Crypto Address",
	"ခရစ်တိုလိပ်စာကို ကော်ပီကူးလိုက်ပါပြီ",
	"Binance ကဲ့သို့ တခြားသော wallet များမှ ခရစ်တိုများကို ရွှေ့ပြောင်းရန် အောက်ပါလိပ်စာကို အသုံးပြုနိုင်ပါသည်။",
	"ရွေ့ပြောင်းနည်း ကြည့်ရန်",
	"ကျန်ရှိသောအချိန် - ",
	"လိပ်စာ ကော်ပီကူးပါ",
	"လိပ်စာသည် ",
	" စက္ကန့်အတွင်းသာ အကျုံးဝင်ပါသည်။ အချိန်မပြည့်ခင် မိမိခရစ်တိုပိုက်ဆံကို ပို့ပေးရန် လိုအပ်ပါသည်။",
	"ခရစ်တိုလိပ်စာ မှားယွင်းနေပါသည်။",
	"ပေးထားသော ငွေတန်ဖိုး မှားယွင်းနေပါသည်။",
	"ငွေထုတ်ယူမည်",
	"ထုတ်ယူလိုသော ခရစ်တို BEP-20 Address ထည့်သွင်းပါ ",
	"BEP-20 Address",
	"USD",
	"ငွေထုတ်ယူမည်",
	"ထုတ်ယူနည်း ကြည့်ရန်",
	"ငွေအမြန်ထုတ်ပါ",
	"သင့် ခရစ်တို BEP-20 Address",
	"လက်ရှိ Address ကိုပြင်ဆင်ပါ",
	"ငွေမည်မျှ ထုတ်ယူလိုပါသလဲ",
	"ငွေထုတ်ယူမည်",
	"နောက်ဆုံးထုတ်ယူထားသော Address များ",
	"ငွေထုတ်မှု လုပ်ဆောင်ချက် ပြုလုပ်ပြီး",
	"ငွေထုတ်ယူမှု အောင်မြင်ပါသည်",
	"ထုတ်ယူထားသော လိပ်စာ:",
	"ထုတ်ယူထားသော အရေအတွက်:",
	"ပြန်ထွက်မည်",
	"သင့်တခြား wallet ဆီသို့ ငွေရောက်ရန် အများဆုံးအချိန်တစ်နာရီခန့် အထိကြာနိုင်ပါသည်။",
	"ငွေထုတ်လိုသော လိပ်စာ",
	"အတည်ပြုပါ",
	"ငွေလွှဲမည့်သူ -",
	"လွှဲမည့် အရေအတွက် -",
	"ပို့ခ Tranfer Fee -",
	"သင့်အကောင့်ထဲ ကျန်ငွေ -",
	"လွှဲမည်",
	"သင့် ကိုယ်ပိုင် Passkey ချိန်ညှိပါ",
	"သင့်ပိုက်ဆံအိပ်ကို အသုံးပြုရန် လှုံခြုံရေးအတွက် ကိုယ်ပိုင် Passkey အရင်ပေးရန် လိုအပ်ပါသည်။",
	"Passkey ပေးမည်",
	"ပို့စ်ပြင်မည်",
	"ပို့စ်ခေါင်းစဉ် ဒီနေရာတွင် ထည့်ပါ",
	"ပို့စ်စာသားများ ပြင်ဆင်မည်",
	"ပြင်ဆင်မည်",
	"ပို့စ်စာ ပြင်ဆင်မည်",
	"Copyright ကိစ္စတိုင်မည်",
	"Copyright တိုင်ချင်သော သင့်ကိုယ်ပိုင် Content ရှိသည့် URL ထည့်သွင်းပါ",
	"ကိုယ်ပိုင် Content URL",
	"Copyright ချိုးဖောက်ခြင်းကို ရှင်းပြပေးပါ။ မှန်ကန်ပါက ကျွန်ုပ်တို့အက်မင်အဖွဲ့မှ ပို့စ်ကိုဖြုတ်ချပေးပါမည်။",
	"Report ဖတ်မည်",
	"Likes ဝယ်ယူမည်",
	"Likes များကို ဝယ်ယူနိုင်ပါသည် -",
	"Apps/Games အသုံးပြုမည်",
	"(သို့) Game နှင့် App တချို့မှလဲ Free Likes ရရှိနိုင်ပါသည် -",
	"Boost စာရင်းများ",
	"There is no boost report for this post.",
	"You are already logged in.",
	"You are not logged in. Please log into your account to make purchase.",
	" - ရှဲလ်ထားသည်"
];